<template>
  <window :window-id="windowId">
    <window-tab :title="windowTitle">
      <div class="form-group form-row">
        <div class="col-sm-3">
          <b-form-select :id="safeId('kategorieId')" v-model="kategorieId" :options="optionsKategorie"
                         text-field="label" value-field="id">
          </b-form-select>
        </div>
        <div class="col-sm-5">
          <b-form-select :id="safeId('wettkampfId')" v-model="wettkampfId" :options="optionsWettkampf"
                         text-field="label" value-field="id">
          </b-form-select>
        </div>
        <div class="col-sm-4">
          <b-form-select :id="safeId('rundeId')" v-model="rundeId" :options="optionsRunde"
                         text-field="label" value-field="id">
          </b-form-select>
        </div>
      </div>
      <table class="table table-bordered table-responsive table-hover table-sm">
        <thead>
        <tr>
          <th>Kat</th>
          <th>Wettkampf</th>
          <th>Runde</th>
          <th>Serie</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="row in filteredCompetitions">
          <td>{{ row.kategorieName }}</td>
          <td>{{ row.disziplinName }}</td>
          <td>{{ row.rundeName }}</td>
          <td>{{ row.serieName}}</td>
          <td>
            <button type="button" class="btn btn-sm btn-primary" @click="openCreateLowerThirds(row)">A</button>
            <button type="button" class="btn btn-sm btn-primary" @click="openCreateStartingList(row)">S</button>
            <button type="button" class="btn btn-sm btn-primary" @click="openCreateRankingList(row)">R</button>
          </td>
        </tr>
        </tbody>
      </table>
    </window-tab>
    <window-tab title="Data" icon="database">
      <div class="form-group form-row">
        <label :for="safeId('endpoint')" class="col-sm-4 col-form-label">Athletica-API</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('endpoint')" v-model.lazy="endpoint">
        </div>
      </div>
      <div class="form-group form-row">
        <div class="col-sm-12">
          <button type="button" class="btn btn-block btn-primary" @click="loadMeetings">Connect</button>
        </div>
      </div>
      <div class="alert alert-danger" v-if="errorMessage">
        <p><b>Error:</b> {{ errorMessage }}</p>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('meetingId')" class="col-sm-4 col-form-label">Meeting</label>
        <div class="col-sm-8">
          <b-form-select :id="safeId('meetingId')" v-model="meetingId" :options="optionsMeeting"
                         text-field="label" value-field="id">
          </b-form-select>
        </div>
      </div>
    </window-tab>
    <window-tab title="Settings" icon="cog">
      <template-settings :template-id="templateId"></template-settings>
    </window-tab>
  </window>
</template>

<script>
  import { uuid } from '@/lib'
  import * as action from '../../store/action-types'
  import { templateMixin } from '@/mixins'
  import { mapTemplateData, mapTemplateOptions } from '../../utils/index'
  import TemplateDefinitionsService from '../../services/template-definitions.service'

  const groupBy = function (xs, key) {
    return xs.reduce(function (rv, x) {
      (rv[x[key]] = rv[x[key]] || []).push(x)
      return rv
    }, {})
  }

  export default {
    name: 'athletica',
    mixins: [templateMixin],
    data () {
      return {
        errorMessage: null,
        meetings: [],
        competitions: [],
        kategorieId: 0,
        wettkampfId: 0,
        rundeId: 0
      }
    },
    computed: {
      ...mapTemplateOptions({'endpoint': {default: 'https://127.0.0.1:9443/'}}),
      ...mapTemplateOptions(['meetingId']),
      ...mapTemplateData(['datasetIds', 'templateIds']),
      filteredCompetitions () {
        return this.competitions.filter(function (each) {
          return (this.wettkampfId <= 0 || each.wettkampfId === this.wettkampfId) &&
            (this.kategorieId <= 0 || each.kategorieId === this.kategorieId) &&
            (this.rundeId <= 0 || each.rundeId === this.rundeId)
        }.bind(this))
      },
      optionsKategorie () {
        const options = [{id: 0, label: ''}]
        const groups = groupBy(this.competitions, 'kategorieId')
        for (let p in groups) {
          if (!groups.hasOwnProperty(p)) continue
          const group = groups[p][0]
          options.push({
            id: group.kategorieId,
            label: group.kategorieName
          })
        }
        return options
      },
      optionsWettkampf () {
        const options = [{id: 0, label: ''}]
        const competitions = this.competitions.filter(function (each) {
          return this.kategorieId <= 0 || each.kategorieId === this.kategorieId
        }.bind(this))
        const groups = groupBy(competitions, 'wettkampfId')
        for (let p in groups) {
          if (!groups.hasOwnProperty(p)) continue
          const group = groups[p][0]
          options.push({
            id: group.wettkampfId,
            label: group.disziplinName
          })
        }
        return options
      },
      optionsRunde () {
        const options = [{id: 0, label: ''}]
        const competitions = this.competitions.filter(function (each) {
          return (this.wettkampfId <= 0 || each.wettkampfId === this.wettkampfId) &&
            (this.kategorieId <= 0 || each.kategorieId === this.kategorieId)
        }.bind(this))
        const groups = groupBy(competitions, 'rundeId')
        for (let p in groups) {
          if (!groups.hasOwnProperty(p)) continue
          const group = groups[p][0]
          options.push({
            id: group.rundeId,
            label: group.rundeName
          })
        }
        return options
      },
      optionsMeeting () {
        return this.meetings.map(each => {
          return {
            id: each.meetingId,
            label: each.name + ', ' + each.ort + ', ' + each.datumVon + ' - ' + each.datumBis
          }
        })
      }
    },
    watch: {
      meetingId () {
        this.loadCompetitions()
      },
      meetings (value) {
        if (!this.meetingId && Array.isArray(value) && value[0].meetingId) {
          // Setting the meetingId will trigger the watch method and thus load
          // the competitions.
          this.meetingId = value[0].meetingId
        } else {
          this.loadCompetitions()
        }
      },
      kategorieId () {
        this.wettkampfId = 0
        this.rundeId = 0
      }
    },
    created () {
      this.templateDefinitionsService = new TemplateDefinitionsService(this.$keycloak, this.$store)
      if (!this.datasetIds) {
        this.datasetIds = [uuid(), uuid(), uuid()]
      }
      if (!this.templateIds) {
        this.templateIds = [uuid(), uuid(), uuid()]
      }
      this.loadMeetings()
    },
    methods: {
      openCreateLowerThirds (competition) {
        const title = competition.kategorieName + ' ' +
          competition.disziplinName + ' ' +
          competition.rundeName + ' ' +
          competition.serieName
        const name = 'Athletes ' + title
        this.openCreate(competition, {
          datasetId: this.datasetIds[0],
          templateId: this.templateIds[0],
          name,
          title,
          componentType: 'lower-third-athlete',
          url: competition.urlStarting,
          templateData: {
            /* eslint-disable no-template-curly-in-string */
            patternBibNumber: '${bibNumber}',
            patternTitle: '${lastName} ${firstName}',
            patternSubtitle: '${club}',
            patternCountry: '${country}'
            /* eslint-enable no-template-curly-in-string */
          },
          overlayData: {
            title: ''
          }
        })
      },
      openCreateStartingList (competition) {
        const title = competition.kategorieName + ' ' +
          competition.disziplinName + ' ' +
          competition.rundeName + ' ' +
          competition.serieName
        const name = 'Starting List ' + title
        const columnMap = {
          'track': 'track',
          'bibNumber': 'bibNumber',
          'lastName': 'lastName',
          'firstName': 'firstName',
          'country': 'country',
          'club': 'club'
        }
        this.openCreate(competition, {
          datasetId: this.datasetIds[1],
          templateId: this.templateIds[1],
          name,
          title,
          columnMap,
          componentType: 'starting-list',
          url: competition.urlStarting
        })
      },
      openCreateRankingList (competition) {
        const title = competition.kategorieName + ' ' +
          competition.disziplinName + ' ' +
          competition.rundeName + ' ' +
          competition.serieName
        const name = 'Ranking List ' + title
        const columnMap = {
          'bibNumber': 'bibNumber',
          'lastName': 'lastName',
          'firstName': 'firstName',
          'country': 'country',
          'club': 'club',
          'rank': 'rank',
          'score': 'resultFormat',
          'windSpeed': 'seriesWindSpeed'
        }
        this.openCreate(competition, {
          datasetId: this.datasetIds[2],
          templateId: this.templateIds[2],
          name,
          columnMap,
          title,
          componentType: 'ranking-list',
          url: competition.urlRanking
        })
      },
      openCreate (competition, options) {
        const datasetId = options.datasetId || uuid()
        console.debug('Creating dataset for competition ' + options.name)
        this.$store.dispatch(action.DATASET_DELETE, {datasetId})
        this.$store.dispatch(action.DATASET_CREATE, {
          datasetId,
          name: 'Dataset ' + options.name,
          dataUrl: options.url
        })
        console.debug('Creating template for competition ' + options.name)
        const template = this.templateDefinitionsService.findTemplateDefinition(options.componentType)
        if (!template) {
          console.error('Could not find template definition with componentType "' + options.componentType + '"')
          return
        }
        template.templateId = options.templateId || uuid()
        template.name = options.name
        template.data = Object.assign({}, options.templateData, {datasetId, columnMap: options.columnMap})
        template.options = Object.assign({}, options.templateOptions)
        template.overlay = {data: Object.assign({}, {title: options.title}, options.overlayData)}
        this.$store.dispatch(action.TEMPLATE_DELETE, {templateId: template.templateId})
        this.$store.dispatch(action.TEMPLATE_CREATE, template)
      },
      loadCompetitions () {
        console.debug('Loading competitions for meeting id ' + this.meetingId)
        this.errorMessage = null
        const request = new XMLHttpRequest()
        const url = this.getUrl('competitions?meetingId=' + this.meetingId)
        request.open('GET', url)
        request.onload = function (event) {
          if (!event.target) {
            this.errorMessage = 'Unknown error'
            return
          }

          if (event.target.status !== 200) {
            this.errorMessage = event.target.statusText
            return
          }

          let response
          try {
            response = JSON.parse(event.target.response)
          } catch (e) {
            this.errorMessage = e.message
            return
          }
          if (response && typeof Array.isArray(response)) {
            this.competitions = response.map(each => {
              each.urlStarting = this.getUrl('starting-lists?serieId=' + each.serieId)
              each.urlRanking = this.getUrl('ranking-lists?serieId=' + each.serieId)
              return each
            })
          } else {
            this.errorMessage = 'Expected the response to be an array'
          }
        }.bind(this)
        request.onerror = function (event) {
          console.log(event)
          this.errorMessage = 'Network error'
        }.bind(this)
        request.send()
      },
      loadMeetings () {
        console.debug('Loading meetings')
        this.errorMessage = null
        const request = new XMLHttpRequest()
        const url = this.getUrl('meetings')
        request.open('GET', url)
        request.onload = function (event) {
          if (!event.target) {
            this.errorMessage = 'Unknown error'
            return
          }

          if (event.target.status !== 200) {
            this.errorMessage = event.target.statusText
            return
          }

          let response
          try {
            response = JSON.parse(event.target.response)
          } catch (e) {
            this.errorMessage = e.message
            return
          }
          if (response && typeof Array.isArray(response)) {
            this.meetings = response
          } else {
            this.errorMessage = 'Expected the response to be an array'
          }
        }.bind(this)
        request.onerror = function (event) {
          console.log(event)
          this.errorMessage = 'Network error'
        }.bind(this)
        request.send()
      },
      getUrl (resource) {
        return (this.endpoint + '/').slice(0, -1) + resource
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/templates/athletica.vue